import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';

const PaymentsTable = ({ handleCategoryPageChange, handlePageChange  }) => {
  const { payments_list, currentPage, totalPages } = useSelector((state) => state.admin_payments);

  return (
    <>
      <div className="table-responsive">
      <table className="table table-striped table-users table-alex text-center printarea">
                    <thead>
                      <tr>
                        <th className="text-start">Client Name</th>
                        <th>Client Email</th>
                        <th>Card Last 4 Digits</th>
                        <th>Card Brand</th>
                        <th>Next Payment Date</th>
                        <th>Period Start</th>
                        <th>Period End</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {payments_list.length > 0 ? (
                        payments_list.map((payment) => (
                          <tr key={payment.id}>
                            <td className="text-start">{payment.user_detail?.first_name || ''} {payment.user_detail?.last_name || ''} </td>
                            <td>{payment.user_detail?.email || 'N/A'}</td>
                            <td>{payment.card_last4 || 'N/A'}</td>
                            <td>{payment.card_brand || 'N/A'}</td>
                            <td>{payment.next_payment_date_display || 'N/A'}</td>
                            <td>{payment.current_period_start_display || 'N/A'}</td>
                            <td>{payment.current_period_end_display || 'N/A'}</td>
                            <td>{payment.created_at_display || 'N/A'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: 'center' }}>No payment records found.</td>
                        </tr>
                      )}
                    </tbody>
      </table>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      </>
  );
};

export default PaymentsTable;